import OutBrain from "common/Layout/Adverts/OutBrain";
import { FC, useContext } from "react";
import { SideBarProps } from "../types/Article.types";
import Topics from "../Topics";
import {
  SideBarWrapper,
  OutbrainWrapper,
  SideBarMpuWrapper,
} from "./SideBar.styled";
import MPU from "common/Layout/Adverts/MPU";
import { ArticleContext } from "../Context";
import { articleTypes } from "../Context/ArticleContext";

interface Props {
  sidebarContent: SideBarProps;
  type: string;
}

const SideBar: FC<Props> = ({ sidebarContent, type }) => {
  const { isDisableOutbrain } = useContext<articleTypes>(ArticleContext);

  if (!sidebarContent) {
    return null;
  }
  if (type === "Service") {
    return null;
  }

  if (type === "Commercial") {
    return null;
  }

  return (
    <SideBarWrapper>
      {sidebarContent.map((item, i) => {
        if (item.type === "MostPopular") return <Topics key={i} />;
        if (item.type === "Outbrain" && !isDisableOutbrain)
          return (
            <OutbrainWrapper key={i}>
              <OutBrain id="AR_2" />
            </OutbrainWrapper>
          );
        if (item.type === "Ad")
          return (
            <SideBarMpuWrapper key={i}>
              <MPU className="article_sidebar" num={2} />
            </SideBarMpuWrapper>
          );
      })}
    </SideBarWrapper>
  );
};

export default SideBar;
